import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import CategoryForm from "../CategoryForm/CategoryForm";
import { ProductStoreCategory } from "../../api/fetchProductStoreCategories/types";
import { useCategoryDialog } from "../../hooks/useCategoryDialog";

interface CategoryDialogProps {
  isOpen: boolean;
  onClose: () => void;
  category?: ProductStoreCategory | null;
  onSuccess?: () => void;
}

const CategoryDialog: React.FC<CategoryDialogProps> = ({
  isOpen,
  onClose,
  category,
  onSuccess,
}) => {
  const { isSubmitting, availableColors, isEditing, handleSubmit } =
    useCategoryDialog({ isOpen, onClose, category, onSuccess });

  return (
    <Dialog onOpenChange={(open) => !open && onClose()} open={isOpen}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            {isEditing ? "Edit Category" : "Create Category"}
          </DialogTitle>
          <DialogDescription>
            {isEditing
              ? "Update the details of this product category."
              : "Fill in the details to create a new product category."}
          </DialogDescription>
        </DialogHeader>
        <CategoryForm
          availableColors={availableColors}
          initialData={category}
          isLoading={isSubmitting}
          onCancel={onClose}
          onSubmit={handleSubmit}
        />
      </DialogContent>
    </Dialog>
  );
};

export default CategoryDialog;
